import { createFileRoute } from '@tanstack/react-router';
import { TravelHub } from '@/features/travel/TravelHub';

export const Route = createFileRoute('/_app/travel')({ component: TravelHub });

// Trasferte (Travel) — modello HR enterprise v2, risorsa dedicata travel-bookings con
// workflow proprio (pm-approve/quote/select-quote/confirm-single/cancel/mark-completed),
// indipendente dai booking legacy /api/bookings.
